export const TABLE_ROWS = ["minla", "maxla"];
export const FAST_CASH_TABLE_ROWS = ["minla", "maxla", "flma", "slma"];
export const CONCILIATION_TABLE_ROWS = ["minPaidPercent"];
export const INFINITE_VALUE = 2147483647;
export const FAST_CASH_LOAN_AMOUNT = 25000
export const LADDER_COLUMNS = ["Description", "Amount"]
